import { getPatients } from './ApiService'
import { PatientSummaryDto } from '../types/swaggerTypes'

/**
 * Looks a patient up in the current institute's patient summary by patient
 * number. Used where a page lost the physician or order number that normally
 * arrives through router state (deep links, refreshes, Data Platform order
 * lines without a physician). Returns undefined when there is no exact match.
 */
export const findPatientSummaryByNumber = async (
  patientNumber: string | undefined
): Promise<PatientSummaryDto | undefined> => {
  const wanted = patientNumber?.trim()
  if (!wanted) {
    return undefined
  }

  const response = await getPatients({
    query: wanted,
    filter: { programs: [], patientOrderStatuses: [] },
    pagination: { skip: 0, take: 10 },
    sorting: { sortBy: 'lastUpdateDate', order: 'desc' }
  })

  return response?.data?.result?.find(
    (patient) => patient.patientNumber?.toUpperCase() === wanted.toUpperCase()
  )
}
